import { createFileRoute } from '@tanstack/react-router';
import { CatalogoPage } from '@/features/catalogo/page/CatalogoPage';
import { useCatalogoStore } from '@/features/catalogo/store/store';
import {
    EmpresaSlugConsultarTipoUso,
    queryOptionsEmpresaSlugConsultar,
} from '@/features/empresa-slug/api/apiEmpresaSlugConsultar';
import { queryClient } from '@/queryClient';

export const Route = createFileRoute('/p/catalogo/$slug')({
    beforeLoad: async (context) => {
        const { empresa } = await queryClient.query(
            queryOptionsEmpresaSlugConsultar({
                slug: context.params.slug,
                tipo_uso: EmpresaSlugConsultarTipoUso.Catalogo,
            }),
        );

        useCatalogoStore.setState({ empresaIdpk: empresa?.emp_idpk ?? null });

        const { isUserLogged, getTokenStatus, renewToken } = useCatalogoStore.getState();

        const logado = isUserLogged();
        if (!logado) {
            return;
        }

        const { status } = getTokenStatus();
        if (status === 'about-to-expire') {
            await renewToken();
        }
    },
    component: CatalogoPage,
});
